import styled from 'styled-components';
import arrowRight from 'assets/images/arrowRight.svg';
import arrowLeft from 'assets/images/arrowLeft.svg';

export const Container = styled.section`
  display: flex;
  width: 100%;

  @media screen and (max-width: 1360px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  width: 50%;
  position: relative;

  .gallery {
    margin-bottom: -4px;
  }

  &.text {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 80px 24px;
    background-color: #1f2b13;
  }

  .slick-prev:before,
  .slick-next:before {
    content: '';
    display: none;
  }

  @media screen and (max-width: 1360px) {
    width: 100%;
  }

  @media screen and (max-width: 500px) {
    &.text {
      padding: 64px 24px;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 570px;
`;

export const Title = styled.h2`
  font-size: 22px;
  text-transform: uppercase;
  margin-bottom: 48px;
`;

export const Text = styled.article`
  font-size: 15px;
  line-height: 25px;

  p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Button = styled.button.attrs({ type: 'button' })`
  position: absolute;
  z-index: 99;
  top: calc(50% - 19px);
  transition: 300ms ease;

  &:hover {
    transform: scale(1.1);
  }

  &.left {
    left: 32px;
  }

  &.right {
    right: 32px;
  }

  @media screen and (max-width: 500px) {
    top: calc(50% - 14px);

    &.left {
      left: 12px;
    }
    &.right {
      right: 12px;
    }
  }
`;

export const ArrowLeftIcon = styled.img.attrs({ src: arrowLeft })`
  @media screen and (max-width: 500px) {
    width: 28px;
  }
`;

export const ArrowRightIcon = styled.img.attrs({ src: arrowRight })`
  @media screen and (max-width: 500px) {
    width: 28px;
  }
`;
